import type { Fragment } from '../translations';

export const repertoire: Fragment = {
  fr: {
    "rep.importReviewShort": "À lier",
    "rep.familyCount": "{n} familles de processus",
    "rep.entryCount": "{n} modèles et demandes",
    "rep.sharedAssignment": "Équipe CdE : {names}. Changer la sélection réattribue l’intervention à la personne choisie.",
    "rep.index": "Index des processus",
    "rep.location": "Domaine sélectionné",
    "rep.refresh": "Actualiser",
    "rep.refreshing": "Actualisation…",
    "rep.refreshError": "Actualisation impossible. Réessayez.",
    "rep.collapse": "Replier {name}",
    "rep.expand": "Déplier {name}",
    "rep.followupHelp": "Suivi CdE : travail en cours et validations. Dernière modif. : dernier commit GitHub du fichier, avec son auteur.",
    "rep.resetFilters": "Afficher tous les processus",
    "rep.variants": "Versions",
    "rep.variantsFor": "Versions de {name}",
    "rep.variantCount": "+{n} versions",
    "rep.actorsHelp": "Intervenants nommés dans les couloirs du diagramme BPMN ; un participant sert de référence quand il n’y a pas de couloir. Ce nombre ne désigne pas des personnes affectées.",
    "rep.unassigned": "À attribuer",
    "rep.unrecorded": "Non renseignées",
    "rep.historyUnavailable": "Historique indisponible",
    "rep.noFile": "Aucun fichier lié",
    "rep.importReview": "Rattachement à vérifier",
    "rep.cancelled": "Annulé",
    "rep.paused": "En pause",

    'rep.allProcesses': 'Tous les processus',
    'rep.root': '(racine)',
    'rep.count': '{n} processus',
    'rep.searchPlaceholder': 'Rechercher un processus, un rôle, une tâche…',
    'rep.groupVersions': 'Grouper les versions',
    'rep.new': 'Nouveau processus',
    'rep.filter.all': 'Tous',
    'rep.filter.live': 'En service',
    'rep.filter.cycle': 'En suivi',
    'rep.filter.documented': 'Documenté',
    'rep.filter.toModel': 'À modéliser',
    'rep.filter.tickets': 'Tickets',
    'rep.state.live': 'En service',
    'rep.state.documented': 'Documenté',
    'rep.state.toModel': 'À modéliser',
    'rep.state.draft': 'Brouillon',
    'rep.state.superseded': 'Remplacé par {code}',
    'rep.state.supersededBare': 'Remplacé',
    'rep.colCode': 'Code',
    'rep.state.step': 'Étape {n}',
    'rep.state.unreadable': 'Illisible',
    'rep.chip.duplicate': 'Doublon',
    'rep.chip.duplicateDivergent': 'Doublon divergent',
    'rep.chip.technical': 'Fichier technique',
    'rep.chip.duplicateTip': 'Existe aussi : {paths}',
    'rep.documentedTip': 'Modèle existant, pas encore passé par le cycle CdE.',
    'rep.toModelTip': 'Fichier vide — le nom est réservé, le modèle reste à faire.',
    'rep.draftTip': 'Enregistrement de cycle sans fichier lié — emplacement prévu.',
    'rep.col.process': 'Processus',
    'rep.col.state': 'Suivi CdE',
    'rep.col.owner': 'Responsable CdE',
    'rep.col.functions': 'Fonctions',
    'rep.col.roles': 'Intervenants BPMN',
    'rep.col.modified': 'Dernière modif.',
    'rep.rolesCount': '{n} rôles',
    'rep.emptyDomain': 'Aucun processus dans ce domaine.',
    'rep.emptyDomainCta': 'Créer le premier',
    'rep.noResults': 'Aucun processus ne correspond à « {q} ».',
    'rep.noResultsHint': 'Essayez le nom d\'un rôle (ex. Secrétariat) ou d\'une étape (ex. facture).',
    'rep.repoDown': 'Le dépôt de processus est momentanément injoignable. Les processus en cycle restent consultables.',
    'rep.syncedAgo': 'synchronisé il y a {when}',
    'rep.openGithub': 'Ouvrir dans GitHub',
    'rep.branch': 'branche {branch}',
    'rep.openCycle': 'Ouvrir une révision de ce processus',
    'rep.reportProblem': 'Signaler un problème',
    'rep.justNow': 'à l\'instant',
    'rep.minutesAgo': '{n} min',
  },
  en: {
    "rep.importReviewShort": "Link needed",
    "rep.familyCount": "{n} process families",
    "rep.entryCount": "{n} models and requests",
    "rep.sharedAssignment": "CdE team: {names}. Changing the selection reassigns this intervention to the selected person.",
    "rep.index": "Process index",
    "rep.location": "Selected domain",
    "rep.refresh": "Refresh",
    "rep.refreshing": "Refreshing…",
    "rep.refreshError": "Refresh failed. Please retry.",
    "rep.collapse": "Collapse {name}",
    "rep.expand": "Expand {name}",
    "rep.followupHelp": "CdE follow-up: current work and approvals. Last modified: the file’s latest GitHub commit and its author.",
    "rep.resetFilters": "Show all processes",
    "rep.variants": "Versions",
    "rep.variantsFor": "Versions of {name}",
    "rep.variantCount": "+{n} versions",
    "rep.actorsHelp": "Actors named in BPMN lanes, or pools when no lanes exist. This is not a count of assigned people.",
    "rep.unassigned": "Unassigned",
    "rep.unrecorded": "Not recorded",
    "rep.historyUnavailable": "History unavailable",
    "rep.noFile": "No linked file",
    "rep.importReview": "Link to review",
    "rep.cancelled": "Cancelled",
    "rep.paused": "Paused",

    'rep.allProcesses': 'All processes',
    'rep.root': '(root)',
    'rep.count': '{n} processes',
    'rep.searchPlaceholder': 'Search a process, a role, a task…',
    'rep.groupVersions': 'Group versions',
    'rep.new': 'New process',
    'rep.filter.all': 'All',
    'rep.filter.live': 'Live',
    'rep.filter.cycle': 'Tracked',
    'rep.filter.documented': 'Documented',
    'rep.filter.toModel': 'To model',
    'rep.filter.tickets': 'Tickets',
    'rep.state.live': 'Live',
    'rep.state.documented': 'Documented',
    'rep.state.toModel': 'To model',
    'rep.state.draft': 'Draft',
    'rep.state.superseded': 'Superseded by {code}',
    'rep.state.supersededBare': 'Superseded',
    'rep.colCode': 'Code',
    'rep.state.step': 'Step {n}',
    'rep.state.unreadable': 'Unreadable',
    'rep.chip.duplicate': 'Duplicate',
    'rep.chip.duplicateDivergent': 'Divergent duplicate',
    'rep.chip.technical': 'Technical file',
    'rep.chip.duplicateTip': 'Also exists: {paths}',
    'rep.documentedTip': 'Existing model, not yet through the CdE cycle.',
    'rep.toModelTip': 'Empty file — the name is reserved, the model remains to be made.',
    'rep.draftTip': 'Cycle record with no linked file — intended location.',
    'rep.col.process': 'Process',
    'rep.col.state': 'CdE follow-up',
    'rep.col.owner': 'CdE lead',
    'rep.col.functions': 'Functions',
    'rep.col.roles': 'BPMN actors',
    'rep.col.modified': 'Last modified',
    'rep.rolesCount': '{n} roles',
    'rep.emptyDomain': 'No processes in this domain.',
    'rep.emptyDomainCta': 'Create the first',
    'rep.noResults': 'No process matches "{q}".',
    'rep.noResultsHint': 'Try a role name (e.g. Secrétariat) or a task (e.g. facture).',
    'rep.repoDown': 'The process repository is temporarily unreachable. Processes in cycle remain available.',
    'rep.syncedAgo': 'synced {when} ago',
    'rep.openGithub': 'Open in GitHub',
    'rep.branch': 'branch {branch}',
    'rep.openCycle': 'Open a revision of this process',
    'rep.reportProblem': 'Report a problem',
    'rep.justNow': 'just now',
    'rep.minutesAgo': '{n} min',
  },
};
